// import React, { useState, useEffect } from 'react'
// import { toast } from 'react-toastify';
// import { apiPut } from '../../../API/Api_Url';

// function ContractorUpdateProfile({ ProUserdata, ChangeTab, GetUserProfile }) {
//     const [isUploading, setIsUploading] = useState(false);

//     const [name, setName] = useState(ProUserdata?.name || "");
//     const [email, setEmail] = useState(ProUserdata?.email || "");
//     const [phone, setPhone] = useState(ProUserdata?.phone || "");
//     const [companyName, setCompanyName] = useState(ProUserdata?.companyName || "");
//     const [city, setCity] = useState(ProUserdata?.City || "");
//     const [location, setLocation] = useState(ProUserdata?.Location || "");
//     const [gstOrCin, setGstOrCin] = useState(ProUserdata?.gstOrCin || "");
//     const [companyAddress, setCompanyAddress] = useState(ProUserdata?.companyAddress || "");

//     useEffect(() => {
//         if (ProUserdata) {
//             setName(ProUserdata.name || "");
//             setEmail(ProUserdata.email || "");
//             setPhone(ProUserdata.phone || "");
//             setCompanyName(ProUserdata.companyName || "");
//             setCity(ProUserdata.City || "");
//             setLocation(ProUserdata.Location || "");
//             setGstOrCin(ProUserdata.gstOrCin || "");
//             setCompanyAddress(ProUserdata.companyAddress || "");
//         }
//     }, [ProUserdata]);

//     const handleUpdateProfile = async () => {
//         try {
//             let data = {
//                 name,
//                 email,
//                 phone,
//                 companyName,
//                 City: city,
//                 Location: location,
//                 gstOrCin,
//                 companyAddress,
//             };

//             setIsUploading(true);
//             const response = await apiPut('api/contractor/update', data);
//             if (response?.data) {
//                 toast.success("Profile updated successfully!");
//                 GetUserProfile();
//                 ChangeTab("Profile");
//             } else {
//                 toast.error(response?.message || "Something went wrong!");
//             }
//         } catch (error) {
//             console.error('Error updating profile:', error);
//             toast.error("Error updating profile.");
//         } finally {
//             setIsUploading(false);
//         }
//     };

//     return (
//         <div className="mx-auto bg-white p-8 rounded-xl shadow-lg">
//             <h2 className="text-2xl font-bold mb-6 text-gray-900 border-b pb-2">
//                 Update Contractor Profile
//             </h2>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <InputField label="Name" type="text" value={name} setValue={setName} />
//                 <InputField label="Email" type="email" value={email} setValue={setEmail} />

//                 <InputField label="Phone Number" type="tel" value={phone} setValue={setPhone} />
//                 <InputField label="Company Name" type="text" value={companyName} setValue={setCompanyName} />

//                 <InputField label="City" type="text" value={city} setValue={setCity} />
//                 <InputField label="Location" type="text" value={location} setValue={setLocation} />

//                 <InputField label="GST / CIN" type="text" value={gstOrCin} setValue={setGstOrCin} />
//                 <InputField label="Company Address" type="text" value={companyAddress} setValue={setCompanyAddress} />

//                 <div className="md:col-span-2">
//                     <button
//                         onClick={handleUpdateProfile}
//                         disabled={isUploading}
//                         className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-2 rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-300"
//                     >
//                         {isUploading ? "Updating..." : "Submit"}
//                     </button>
//                 </div>
//             </div>

//         </div>
//     )
// }

// const InputField = ({ label, type, value, setValue }) => (
//     <div>
//         <label className="block text-gray-700 font-medium mb-1">{label}</label>
//         <input
//             type={type}
//             value={value}
//             onChange={(e) => setValue(e.target.value)}
//             placeholder={`Enter ${label.toLowerCase()}`}
//             className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//         />
//     </div>
// );

// export default ContractorUpdateProfile;

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { apiPut } from "../../../API/Api_Url";

function ContractorUpdateProfile({ ProUserdata, ChangeTab, GetUserProfile }) {
    const [isUploading, setIsUploading] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [city, setCity] = useState("");
    const [location, setLocation] = useState("");
    const [gstOrCin, setGstOrCin] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [subRole, setSubRole] = useState("");
    const [yearsInBusiness, setYearsInBusiness] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [servicesOffered, setServicesOffered] = useState("");
    const [skills, setSkills] = useState("");
    const [geographicalAreas, setGeographicalAreas] = useState("");
    const [totalWorkers, setTotalWorkers] = useState("");
    const [additionalNotes, setAdditionalNotes] = useState("");

    useEffect(() => {
        if (ProUserdata) {
            setName(ProUserdata?.name || "");
            setEmail(ProUserdata?.email || "");
            setPhone(ProUserdata?.phone || "");
            setCompanyName(ProUserdata?.companyName || "");
            setCity(ProUserdata?.City || "");
            setLocation(ProUserdata?.Location || "");
            setGstOrCin(ProUserdata?.gstOrCin || "");
            setCompanyAddress(ProUserdata?.companyAddress || "");
            setSubRole(ProUserdata?.SubRole || "");
            setYearsInBusiness(ProUserdata?.yearsInBusiness || "");
            setContactPerson(ProUserdata?.contactPerson || "");
            setServicesOffered(ProUserdata?.servicesOffered?.join(", ") || "");
            setSkills(ProUserdata?.skills?.join(", ") || "");
            setGeographicalAreas(ProUserdata?.geographicalAreas || "");
            setTotalWorkers(ProUserdata?.totalWorkers || "");
            setAdditionalNotes(ProUserdata?.additionalNotes || "");
        }
    }, [ProUserdata]);

    const handleUpdateProfile = async () => {
        try {
            let data = {
                name,
                email,
                phone,
                companyName,
                City: city,
                Location: location,
                gstOrCin,
                companyAddress,
                SubRole: subRole,
                yearsInBusiness,
                contactPerson,
                servicesOffered: servicesOffered
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean),
                skills: skills
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean),
                geographicalAreas,
                totalWorkers,
                additionalNotes,
            };

            setIsUploading(true);
            const response = await apiPut("api/contractor/update", data);

            if (response?.data) {
                toast.success("Profile updated successfully!");
                GetUserProfile();
                ChangeTab("Profile");
            } else {
                toast.error(response?.message || "Something went wrong!");
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("Error updating profile.");
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="mx-auto bg-white p-8 rounded-xl shadow-lg">
            <h2 className="text-2xl font-bold mb-6 text-gray-900 border-b pb-2">
                Update Contractor Profile
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <InputField label="Name" type="text" value={name} setValue={setName} />
                <InputField
                    label="Email"
                    type="email"
                    value={email}
                    setValue={setEmail}
                />

                <InputField
                    label="Phone Number"
                    type="tel"
                    value={phone}
                    setValue={setPhone}
                />
                <InputField
                    label="Company Name"
                    type="text"
                    value={companyName}
                    setValue={setCompanyName}
                />

                <InputField label="City" type="text" value={city} setValue={setCity} />
                <InputField
                    label="Location"
                    type="text"
                    value={location}
                    setValue={setLocation}
                />

                <InputField
                    label="GST / CIN"
                    type="text"
                    value={gstOrCin}
                    setValue={setGstOrCin}
                />
                <InputField
                    label="Company Address"
                    type="text"
                    value={companyAddress}
                    setValue={setCompanyAddress}
                />

                <InputField
                    label="Sub Role"
                    type="text"
                    value={subRole}
                    setValue={setSubRole}
                />
                <InputField
                    label="Years in Business"
                    type="number"
                    value={yearsInBusiness}
                    setValue={setYearsInBusiness}
                />
                <InputField
                    label="Contact Person"
                    type="text"
                    value={contactPerson}
                    setValue={setContactPerson}
                />
                <InputField
                    label="Services Offered (comma separated)"
                    type="text"
                    value={servicesOffered}
                    setValue={setServicesOffered}
                />
                <InputField
                    label="Skills (comma separated)"
                    type="text"
                    value={skills}
                    setValue={setSkills}
                />
                <InputField
                    label="Geographical Areas"
                    type="text"
                    value={geographicalAreas}
                    setValue={setGeographicalAreas}
                />
                <InputField
                    label="Total Workers"
                    type="number"
                    value={totalWorkers}
                    setValue={setTotalWorkers}
                />
                <InputField
                    label="Additional Notes"
                    type="text"
                    value={additionalNotes}
                    setValue={setAdditionalNotes}
                />
                <div className="md:col-span-2">
                    <button
                        onClick={handleUpdateProfile}
                        disabled={isUploading}
                        className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-2 rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-300"
                    >
                        {isUploading ? "Updating..." : "Submit"}
                    </button>
                </div>
            </div>
        </div>
    );
}

const InputField = ({ label, type, value, setValue }) => (
    <div>
        <label className="block text-gray-700 font-medium mb-1">{label}</label>
        <input
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder={`Enter ${label.toLowerCase()}`}
            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
    </div>
);

export default ContractorUpdateProfile;
